import { useState, useEffect } from 'react';
import { getSiteDepartments } from 'services/analytics';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { showError } from '../../../../../redux/common/actions';
import { SHOW_ALL_OPTION } from '../../constants';

export const useDepartments = (siteAppID, showAll = true) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    const loadDepartments = async () => {
      try {
        const response = await getSiteDepartments(siteAppID);
        if (response?.status) {
          const fetchedDepartments = response.data || [];
          // Only add 'Show All' if there are actual departments and showAll is true
          const updatedDepartments = (showAll && fetchedDepartments.length > 0)
            ? [SHOW_ALL_OPTION, ...fetchedDepartments]
            : fetchedDepartments;
          setDepartments(updatedDepartments);
        }
      } catch (error) {
        dispatch(showError(t('message.failedToLoadDepartments')));
      }
    };
    loadDepartments();
  }, [siteAppID, showAll, dispatch, t]);

  return departments;
}; 